var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center mb-2", attrs: { "no-gutters": "" } },
    [
      _c("b-col", { attrs: { cols: "auto" } }, [
        _vm.titleType === "title"
          ? _c(
              "h4",
              { staticClass: "mb-0 text-primary" },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.titleType === "subtitle"
          ? _c(
              "h5",
              { staticClass: "application-summary-subtitle mb-0 text-primary" },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.$slots["actions"]
        ? _c("b-col", { staticClass: "ml-2" }, [_vm._t("actions")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }